import { atom } from "recoil";
import { ModalType } from "../@types";
import { ClipContext } from "MVVM/Views/ClipExperience/@types";

interface IClipFullModal {
  isOpen: ModalType;
  shareId: string;
  orientation?: string;
  contextOverride?: ClipContext | null;
}

export const AllstarModalState = atom({
  key: "AllstarModalState_v0.1",
  default: {
    data: {} as any,
    functions: {} as any,
    isOpen: ModalType.None,
  },
});

export const ClipFullModalState = atom({
  key: "ClipFullModalState_v0.1",
  default: {
    isOpen: ModalType.None,
    shareId: "",
    orientation: "LANDSCAPE",
    contextOverride: null,
  } as IClipFullModal,
});
